var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResizeArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4206 8.30914C30.1566 6.88079 25.5433 6.88079 21.2793 8.30914",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47.39 34.4198C48.8183 30.1558 48.8183 25.5424 47.39 21.2784",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.31085 21.2784C6.8825 25.5424 6.8825 30.1558 8.31085 34.4198",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2793 47.3891C25.5433 48.8175 30.1566 48.8175 34.4206 47.3891",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5423 15.1572L32.4355 23.2639",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0566 15.1572H40.5425V21.6431",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 15.1572L23.2649 23.2639",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 21.6431V15.1572H21.644",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5423 40.5412L32.4355 32.4344",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5425 34.0552V40.541H34.0566",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1582 40.5412L23.2649 32.4344",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.644 40.541H15.1582V34.0552",
    stroke: "#384336",
    strokeWidth: 3.19072,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResizeArrows);
export default __webpack_public_path__ + "static/media/resize-arrows.01cfbb5f.svg";
export { ForwardRef as ReactComponent };